module.exports = {
  text: `Никогда не полагайтесь на что-то построенное гномами. Гном всегда может придумать хорошую идею и сделать её совершенно непрактичной`,
  author: `Архимаг Морденкайнен`,
}
